const breadcrumbs = (_options:{cssClass?:string, targetList?:string}) => {
  const opt = {
    cssClass: 'PageBreadcrumbs',
    targetList: 'ul',
    ..._options
  }
  const target: string = `.${opt.cssClass}`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${opt.cssClass}`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${opt.cssClass}`] = true;

    // listen position of scroll and place layers scrollEnd and scrollStart if needed

    const content = elt.querySelector(opt.targetList);
    content.scrollTo(content.scrollWidth - elt.clientWidth, 0);
    const checkScrollPos = ()=>{
      const scrollRight = content.scrollWidth - elt.clientWidth - 1;
      if(content.scrollLeft === 0) {
        elt.classList.add('isScrolledLeft');
      } else {
        elt.classList.remove('isScrolledLeft');
      }
      if(content.scrollLeft >= scrollRight) {
        elt.classList.add('isScrolledRight');
      } else {
        elt.classList.remove('isScrolledRight');
      }
    }
    checkScrollPos();
    content.addEventListener('scroll', (_event:Event)=>{
      checkScrollPos();
    });

  }
};

export default breadcrumbs;
